import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import heroImage from './hero-img/hero.svg';
import TypeWriterEffect from "react-typewriter-effect";
import '../../App.css';
import styles from '../../App.css';

const Home = () => {
  
  document.title = "Veta - Beautiful Free Images & Pictures";

  return (
    <div className="App">
      <div className="container">
        <div className="Hero">
            <div className="Hero-text">
              <h1 className="title">
                <TypeWriterEffect
                  style={styles.title}
                  startDelay={0}
                  cursorColor="gray"
                  text="Browse Beautiful Free Images & Pictures."
                  typeSpeed={70}
                />
              </h1>
              <p>Explore freely high quality images posted by creators everywhere.</p>
              <Link to="/search" className="divedeep">
                <span>Dive Deep</span>
                <img src="https://img.icons8.com/external-outline-lafs/64/ffffff/external-Explore-smart-contract-and-testnet-outline-lafs.png" height="20px"/>
              </Link>
          </div>

          <div className="Hero-img">
            <img src={heroImage} alt="Hero-image" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home;